document.addEventListener('DOMContentLoaded', function() {
  const giftWrapModals = document.querySelectorAll('.Modal--giftWrap');
  
  giftWrapModals.forEach(function(modal) {
    if (modal && !modal.hasAttribute('data-moved')) {
      document.body.appendChild(modal);
      modal.setAttribute('data-moved', 'true');
    }
  });
});

